// src/Login.js

import React, { useState, useEffect } from "react";
import { setTenantId, getUserManager } from "./AuthService";
import './LoginOauth.css';

function TenantPage() {
  const tenants = [
    { id: "8a1c6c5b-0062-4555-abe4-98a992364e35", name: "besthomes" },
    { id: "9d015545-bc73-417c-832f-dcbdf64a7230", name: "lego" },
    { id: "d91bfdc2-7cf8-4461-b8dd-e5e8bb7aec13", name: "avto-oils" },
  ];
  const [tenantId, setTenant] = useState(tenants[0].id);
  const [autoLoginAttempted, setAutoLoginAttempted] = useState(false);
  const isLocalhost = window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1');


  // Helper to get tenant from hostname
  function getTenantFromHostname() {
    const hostname = window.location.hostname;
    // Extract subdomain from hostname (e.g., "besthomes" from "besthomes.nap-pro.com")
    const subdomain = hostname.split('.')[0];
    console.log("Detected subdomain:", subdomain);

    // Convert subdomain to proper tenant name format
    let tenantName;
    switch (subdomain.toLowerCase()) {
      case 'besthomes':
        tenantName = 'besthomes';
        break;
      case 'lego':
        tenantName = 'lego';
        break;
      case 'avto-oils':
        tenantName = 'avto-oils';
        break;
      default:
        return null;
    }
    return tenantName;
  }

  // Try to auto-detect tenant on mount
  useEffect(() => {
    if (!autoLoginAttempted) {
      const detectedTenant = getTenantFromHostname();
      if (detectedTenant) {
        const foundTenant = tenants.find(t => t.name === detectedTenant);
        if (foundTenant) {
          setTenant(foundTenant.id);
          setTenantId(foundTenant.id);
          setAutoLoginAttempted(true);
          handleLogin(foundTenant.id, true);
        }
      }
    }
  }, [autoLoginAttempted]);

  // Login handler
  const handleLogin = async (id = tenantId, auto = false) => {
    setTenantId(id);
    const userManager = getUserManager();
    if (auto) {
      await userManager.signinRedirect();
    }
    // For manual login, only redirect if button pressed
    if (!auto) {
      await userManager.signinRedirect();
    }
  };

  // On tenant select, persist in cookie
  const handleTenantChange = (e) => {
    setTenant(e.target.value);
    if (window.location.hostname.includes('localhost')) {
      const selectedTenant = tenants.find(t => t.id === e.target.value);
      if (selectedTenant) {
        localStorage.setItem('tenantName', selectedTenant.name);
      }
    }
  };

  if (!isLocalhost) {
    return null;
  }

  return (
    <div className="login-oauth-container">
      <h2>Вход</h2>
      <label>
        Моля изберете вашата фирма:
        <select
          value={tenantId}
          onChange={handleTenantChange}
        >
          {tenants.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
      </label>
      <button onClick={() => handleLogin(tenantId, false)}>
        Вход
      </button>
    </div>
  );
}

export default function LoginOauth() {
  return (
    <TenantPage />
  );
}
